export default "__VITE_ASSET__B9V3Ariw__"